import React from 'react';
import jQuery from 'jquery';
import Configurator from './Configurator.jsx';
import styles from './EnclosureClimateConfigurator.styl';
import Dropdown from "./ui/Dropdown.jsx";
import TextInput from "./ui/TextInput.jsx";
import Image from "./ui/Image.jsx";
import Button from "./ui/button/Button.jsx";


const MODE_NONE = 0;
const MODE_HEATER = 1;
const MODE_FAN = 2;

const HEATER_TYPE_DEFAULT = 0;
const HEATER_TYPE_SAFE = 1;
const HEATER_TYPE_MINI = 2;
const HEATER_TYPE_POWERFUL = 3;
const HEATER_TYPE_COMPACT_IN_CASE = 4;
const HEATER_TYPE_COMPACT_FLAT = 5;
const HEATER_TYPE_EXPLOSION_PROOF_IP65_EX = 6;

const FAN_TYPES = [{value: 0, text: "Стандартный 230В"}];

/**
 * Конфигуратор по подбору климатического оборудования для для шкафов
 */
class EnclosureClimateConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = {

			// Параметры шкафа
			enclosureHeight:   1000, // Высота, мм
			enclosureWidth:     800, // Ширина, мм
			enclosureDepth:     300, // Глубина, мм
			enclosureMaterial:    0, // Материал
			place:                0, // Тип установки

			power: 0, // Мощность тепловыделения оборудования, Вт

			// Параметры окружающей среды
			h:         0, // Высота над уровнем моря
			envTmax:  35, // Температура окр среды (макс)
			envTmin: -30, // Температура окр среды (мин)
			rh:       69, // Средняя относительная влажность

			// Требуемая температура внутри шкафа
			insideTmax: 45, // Максимальная
			insideTmin: 15, // Минимальная

			mode: MODE_NONE, // 1-подбрать обогреватель; 2-подобрать вентилятор

			canPickHeater: true, // Кнопка подобрать обогреватель активна
			canPickFan:    true, // Кнопка подобрать вентилятор активна

			heaterOptionSafe:    false, // Использовать безопасный обогреватель
			heaterOptionOpenAir: false, // Разместить на открытом пространстве
			heaterOptionMini:    false, // Использовать мини-обогреватель (для ЩУ и ЩУРн)
			heaterOptionPowerful: false, // Использовать мощные обогреватели
			heaterOptionCompactInCase: false, // Использовать компактный в корпусе
			heaterOptionCompactFlat: false, // Использовать компактный плоский
			heaterOptionExplosionProofIP65Ex: false, // Использовать взрывозащищенный IP65 Ex
			fanOptionGrill:      false, // Использовать выпускную решетку с фильтром
			fanOptionHalfClosedGrill: false, // Использовать полузакрытый тип решетки

			specListHeaters:      {}, // Перечень подобранных обогревателей
			specListFans:         {}, // Перечень подобранных вентиляторов
			specListFanAccessory: {}, // Перечень подобранных аксессуаров для вентиляторов
			specListClimateControl: {}, // Перечень подобранных устройств контроля

			climateControls: null, // Список устройств контроля для выбранного режима

			showPowerCalc: false, // Узнать мощность тепловыделения
			equipment: [],
			equipmentList: [],
			equipmentListTotal: 0
		};

		this.onSpecListSelectItem = this.onSpecListSelectItem.bind(this);
		this.onSpecListDeleteItem = this.onSpecListDeleteItem.bind(this);
		this.onBtnPickUp          = this.onBtnPickUp.bind(this);
		this.onClimateControlChange = this.onClimateControlChange.bind(this);
		this.onBtnExcelClick      = this.onBtnExcelClick.bind(this);
		this.onPowerCalcOK        = this.onPowerCalcOK.bind(this);
		this.onChangeHeaterType   = this.onChangeHeaterType.bind(this);
		this.onModeChange         = this.onModeChange.bind(this);
	}

	componentDidMount() {
		super.componentDidMount()
		const urlParams = new URLSearchParams(window.location.search);
		const qParams = [
			'enclosureHeight', 'enclosureWidth', 'enclosureDepth', 'enclosureMaterial', 'place', 'power', 'envTmax',
			'envTmin', 'insideTmax', 'insideTmin', 'h'
		]
		const qObj = {}
		qParams.map(item => {
			const paramVal = urlParams.get(item)
			if(paramVal && !isNaN(paramVal)) qObj[item] = paramVal
		})

		this.setState({
			...qObj
		});
	}

	getType() {
		return 'enclosure_climate';
	}

	getCustomStyles() {
		return styles;
	}

	loadDb() {
		const self = this;

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				self.db = db;
				self.forceUpdate();
			}
		);

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'enclosure_climate',
				action: 'getJson',
				name: 'equipment'
			},
			equipment => {
				self.setState({
					equipment
				});
			});
	}

	/**
	 * Расчет
	 *
	 * @returns {{s: number, airflow: number, pheat: number}}
	 */
	calc() {
		let calc = {
			s:       0, // Поверхность теплообмена корпуса шкафа
			//trh:   0, // Температура точки росы
			airflow: 0, // Требуемый воздушный поток
			//pcool: 0, // Требуемая мощность охлаждения
			pheat:   0  // Требуемая мощность нагрева
		};


		// Поверхность теплообмена корпуса шкафа
		const I5 = parseFloat(this.state.enclosureHeight) / 1000;
		const I6 = parseFloat(this.state.enclosureWidth)  / 1000;
		const I7 = parseFloat(this.state.enclosureDepth)  / 1000;

		const HEIGHT = I5;
		const WIDTH  = I6;
		const DEPTH  = I7;

		switch (parseInt(this.state.place))
		{
			// Отдельно стоящий шкаф, свободный доступ
			case 0:
				calc.s = (1.8 * HEIGHT * (WIDTH + DEPTH) + 1.4 * WIDTH * DEPTH);
				break;

			// Отдельно стоящий шкаф около стены
			case 1:
				calc.s = (1.4 * WIDTH * (HEIGHT + DEPTH) + 1.8 * DEPTH * HEIGHT);
				break;

			// Шкаф в конце ряда, свободный доступ
			case 2:
				calc.s = (1.4 * DEPTH * (HEIGHT + DEPTH) + 1.8 * HEIGHT * WIDTH);
				break;

			// Шкаф в конце ряда около стены
			case 3:
				calc.s = (1.4 * HEIGHT * (DEPTH + WIDTH) + 1.4 * DEPTH * WIDTH);
				break;

			// Шкаф в середине ряда, свободный доступ
			case 4:
				calc.s = (1.8 * HEIGHT * WIDTH + 1.4 * DEPTH * WIDTH + DEPTH * HEIGHT);
				break;

			// Шкаф в середине ряда около стены
			case 5:
				calc.s = (1.4 * WIDTH * (HEIGHT + DEPTH) + DEPTH * HEIGHT);
				break;

			// Шкаф в середине ряда около стены, с козырьком
			case 6:
				calc.s = (1.4 * WIDTH * HEIGHT + 0.7 * DEPTH * WIDTH + DEPTH + HEIGHT);
				break;
		}

		//


		// Требуемая мощность охлаждения/нагрева/воздушный поток
		const I9  = parseInt(this.state.enclosureMaterial);
		//const I10 = parseFloat(this.state.h);
		const I10 = parseInt(this.state.h);

		const I39 = calc.s;
		const I41 = parseFloat(this.state.power);
		const I42 = parseFloat(this.state.envTmax);
		const I43 = parseFloat(this.state.envTmin);
		const I44 = parseFloat(this.state.insideTmax);
		const I47 = parseFloat(this.state.insideTmin);

		const pk = I39 * (I9===0 ? 5.5 : (I9===1 ? 4.5 : (I9===2 ? 12 : (I9===3 ? 4.5 : (I9===4 ? 3.5 : 0)))));

		//const pcool = I41-pk*(I44-I42);
		//const pheat = pk*(I47-I43)-I41;

		calc.pheat = pk*(I47-I43)-I41;

		if (this.state.heaterOptionOpenAir)
		{
			// На открытом пространстве требуется двойная мощность
			calc.pheat *= 2;
		}

		//calc.pcool = pcool <= 0 ? '-' : pcool.toFixed(0);
		//calc.pheat = pheat <= 0 ? 0 : pheat.toFixed(0);

		// https://www.stego.de/nc/ru/servisnoe-obsluzhivanie/onlain-raschet/raschjot-moshchnosti-okhlazhdenija/
		const tdelta = I44 - I42;
		if (tdelta > 0)
		{
			const airflow_f = (I10 === 0 ? 3.1 : (I10 === 1 ? 3.2 : (I10 === 2 ? 3.3 : (I10 === 3 ? 3.4 : (I10 === 4 ? 3.5 : 0)))));
			calc.airflow = (airflow_f * I41) / tdelta;
			//calc.airflow = calc.airflow.toFixed(0);
		}
		else
		{
			calc.airflow = 0;
		}


		//const airflow = (I44-I42>0 ? ((I41-I39*(I9==='A' ? 5.5 : (I9==='B' ? 3.5 : (I9==='C' ? 3.7 : (I9==='D' ? 12 : 0))))*(I44-I42))/(I44-I42))*(Math.pow(I10, 0.52)/80+Math.pow(I10, 1.84)/2000000+3) : 0);
		//calc.airflow = airflow <= 0 ? '-' : airflow.toFixed(0);
		//


		// Температура точки росы
		//const I45 = parseFloat(this.state.rh);
		//calc.trh = (237.7*(17.27*I42/(237.7+I42)+Math.log(I45/100))/(17.27-(17.27*I42/(237.7+I42)+Math.log(I45/100)))).toFixed(0);
		//

		return calc;
	}

	/**
	 * Возвращает полный перечень подобранных аксессуаров
	 */
	getFullSpecList() {
		return jQuery.extend(
			{},
			this.state.specListHeaters,
			this.state.specListFans,
			this.state.specListFanAccessory,
			this.state.specListClimateControl
		);
	}

	doPrint(params) {
		let _params = params || {};

		_params.data = {
			speclist: JSON.stringify(this.getFullSpecList())
		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	onSpecListSelectItem(item) {
		this.setState(() => {
			return {item};
		});
	}

	onPowerCalcOK(value, equipmentList) {
		this.setState({
			power: value,
			showPowerCalc: false,
			equipmentList
		});
	}

	/**
	 * Удаление позиции из перечня подобранных аксессуаров
	 * @param item
	 */
	onSpecListDeleteItem(item) {
		this.setState(prevState => {
			let specListHeaters      = jQuery.extend({}, prevState.specListHeaters);
			let specListFans         = jQuery.extend({}, prevState.specListFans);
			let specListFanAccessory = jQuery.extend({}, prevState.specListFanAccessory);
			let specListClimateControl   = jQuery.extend({}, prevState.specListClimateControl);

			delete specListHeaters[item.article];
			delete specListFans[item.article];
			delete specListFanAccessory[item.article];
			delete specListClimateControl[item.article];

			let newState = {specListHeaters, specListFans, specListFanAccessory, specListClimateControl};

			if (prevState.item && prevState.item.article === item.article)
			{
				newState.item = null;
			}

			if (jQuery.isEmptyObject(specListClimateControl))
			{
				jQuery.extend(newState, {canPickFan: true, canPickHeater: true});
			}

			return newState;
		});
	}

	/**
	 * Добавление устройства контроля
	 * @param article
	 */
	onClimateControlChange(article) {
		if (article === '') {
			return;
		}

		this.setState(prevState => {
			const specListClimateControl = jQuery.extend({}, prevState.specListClimateControl);

			specListClimateControl[article] = this.getClimateControlByArticle(article);

			return {
				specListClimateControl
			};
		});
	}


	/**
	 * Алгоритм подбора обогревателей/вентиляторов
	 */
	calcPick(itemList, needValue, propName, resList = {}) {
		let calcItem = null;

		for (let i = 0; i < itemList.length; i++)
		{
			const item = itemList[i];

			if (calcItem !== null)
			{
				if (parseInt(item[propName]) <= needValue)
				{
					if (parseInt(calcItem[propName]) < parseInt(item[propName])) {
						calcItem = item;
					}
				}
				else if (parseInt(calcItem[propName]) < needValue && parseInt(item[propName]) > parseInt(calcItem[propName]))
				{
					calcItem = item;
				}
				else if (parseInt(calcItem[propName]) > needValue && parseInt(item[propName]) > needValue && parseInt(calcItem[propName]) > parseInt(item[propName]))
				{
					calcItem = item;
				}
			}
			else
			{
				calcItem = item;
			}
		}

		calcItem = jQuery.extend({}, calcItem);

		if (resList[calcItem.article])
		{
			resList[calcItem.article].count++;
			resList[calcItem.article].name = `${resList[calcItem.article].count} × ${calcItem.name}`;

			if (resList[calcItem.article].count === 10 && this.state.heaterOptionMini) {
				alert('Использование мини-обогревателей при введенных условиях не целесообразно. Уберите галочку «мини-обогреватель».');
			}
		}
		else
		{
			resList[calcItem.article] = calcItem;
			resList[calcItem.article].count = 1;
		}

		needValue -= parseInt(calcItem[propName]);

		if (needValue > 0) { // Требуется еще
			this.calcPick(itemList, needValue, propName, resList);
		}

		return resList;
	}

	/**
	 * Подобрать обогреватель / Подобрать вентилятор
	 * @param mode
	 */
	onModeChange(mode) {
		const climateControlsByMode = this.db.climate_control.filter(cc => {
			if (mode === MODE_HEATER) {
				return parseInt(cc.use_heater) === 1;
			} else if (mode === MODE_FAN) {
				return parseInt(cc.use_fan) === 1;
			}

			return false;
		});

		const climateControls = climateControlsByMode.map(cc => {
			return {
				value: cc.article,
				text:  cc.name
			};
		});

		climateControls.unshift({value: '', text: ''});

		this.setState({
			mode,
			climateControls
		});
	}

	/**
	 * Подобрать (расчет)
	 */
	onBtnPickUp() {

		if (this.state.mode !== MODE_HEATER && this.state.mode !== MODE_FAN)
		{
			return;
		}

		// Выполняем расчеты
		const calcResults = this.calc();

		if (this.state.mode === MODE_HEATER)
		{
			// Подобрать обогреватель

			this.setState({specListHeaters: {}, item: null});

			// Если требуемая мощность нагрева <= 0, обогреватель не требуется
			if (calcResults.pheat <= 0) {
				return;
			}

			// Фильтр списка обогревателей по типу
			const heaterList = this.db.heaters.filter(heater => {

				if (this.state.heaterOptionSafe) {
					return (heater.type === HEATER_TYPE_SAFE);
				} else if (this.state.heaterOptionMini) {
					return (heater.type === HEATER_TYPE_MINI);
				} else if (this.state.heaterOptionPowerful) {
					return (heater.type === HEATER_TYPE_POWERFUL);
				} else if (this.state.heaterOptionCompactInCase) {
					return (heater.type === HEATER_TYPE_COMPACT_IN_CASE);
				} else if (this.state.heaterOptionCompactFlat) {
					return (heater.type === HEATER_TYPE_COMPACT_FLAT);
				} else if (this.state.heaterOptionExplosionProofIP65Ex) {
					return (heater.type === HEATER_TYPE_EXPLOSION_PROOF_IP65_EX);
				}

				return (heater.type === HEATER_TYPE_DEFAULT);
			});

			if (heaterList.length === 0) {
				this.setState({specListHeaters: [], item: null});
				return;
			}

			// Подбор обогревателя(-ей) по требуемой мощности нагрева
			const specListHeaters = this.calcPick(heaterList, calcResults.pheat, 'power');

			// Обновляем перечень подобранных обогревателей
			this.setState({specListHeaters, item: null});
		}
		else if (this.state.mode === MODE_FAN)
		{
			// Подобрать вентилятор

			this.setState({specListFans: {}, specListFanAccessory: {}, item: null});

			// Если требуемый воздушный поток <= 0, вентилятор не требуется
			if (calcResults.airflow <= 0) {
				return;
			}

			// Фильтр списка обогревателей по типу безопасности
			const fanList = this.db.fans.filter(fan => {

				// Если ничего не выбрано, выбираем Вентилятор с фильтром ВФИ
				if (!this.state.fanOptionGrill && !this.state.fanOptionHalfClosedGrill) {
					return /^YVR10-/.test(fan.article);
				}

				// Использовать выпускную решетку с фильтром
				if (this.state.fanOptionGrill && !this.state.fanOptionHalfClosedGrill) {
					return /^YVR10-/.test(fan.article);
				}

				// Использовать полузакрытый тип решетки
				if (!this.state.fanOptionGrill && this.state.fanOptionHalfClosedGrill) {
					return /^YCE-FF-/.test(fan.article);
				}

				// Использовать выпускную решетку с фильтром + Использовать полузакрытый тип решетки
				if (this.state.fanOptionGrill && this.state.fanOptionHalfClosedGrill) {
					return /^YCE-FF-/.test(fan.article);
				}

				return true;
			});

			// Подбор вентилятора(-ов) по требуемому воздушному потоку
			const specListFans = this.calcPick(fanList, calcResults.airflow, 'cmh');

			// Подбор аксессуаров для вентиляторов, если стоит галка "Использовать выпускную решетку с фильтром"
			let specListFanAccessory = {};

			if (this.state.fanOptionGrill)
			{
				Object.keys(specListFans).forEach(article => {

					for (let i = 0; i < this.db.fan_accessory.length; i++)
					{
						const fa = this.db.fan_accessory[i];

						if (fa.fan_article === article)
						{
							specListFanAccessory[fa.article] = fa;
							break;
						}
					}

				});
			}

			// Обновляем перечень подобранных вентиляторов и аксессуаров к ним
			this.setState({specListFans, specListFanAccessory, item: null});
		}
	}

	onChangeHeaterType(heaterTypeOption, checked) {
		const hto = {
			heaterOptionSafe: false,
			heaterOptionMini: false,
			heaterOptionPowerful: false,
			heaterOptionCompactInCase: false,
			heaterOptionCompactFlat: false,
			heaterOptionExplosionProofIP65Ex: false
		};

		hto[heaterTypeOption] = checked;

		this.setState(hto);
	}

	/**
	 * Проверка поля ввода числовых данных
	 */
	checkNumberInputValue(value) {
		if (value.endsWith('.') || value.endsWith('0') || value === '-') {
			return value;
		}

		const v = parseFloat(value);

		return (isNaN(v) ? '' : v);
	}

	/**
	 * Возвращает устройство контроля по его артикулу
	 */
	getClimateControlByArticle(article) {
		for (let i = 0; i < this.db.climate_control.length; i++)
		{
			const ts = this.db.climate_control[i];
			if (ts.article === article) {
				return ts;
			}
		}

		return null;
	}


	render() {
		if (!this.db) {
			return <div className={styles.cfg} />;
		}

		const calcResults = this.calc();
		const specList    = this.getFullSpecList();

		const canPickHeater = this.state.canPickHeater && this.state.mode === MODE_HEATER && calcResults.pheat > 0;
		const canPickFan    = this.state.canPickFan && this.state.mode === MODE_FAN && calcResults.airflow > 0;


		let showThermostatWarn = false;
		let thermostatWarnMsg = '';

		if (!jQuery.isEmptyObject(specList))
		{
			let hasThermostat = false;

			for (const cc in this.state.specListClimateControl)
			{
				if (this.state.specListClimateControl[cc].name.indexOf('Термостат') !== -1)
				{
					hasThermostat = true;
					break;
				}
			}

			if (!hasThermostat)
			{
				showThermostatWarn = true;
				thermostatWarnMsg = 'ВНИМАНИЕ! Для корректной работы системы необходимо выбрать термостат';
			}
		}
		// else if (this.state.currentThermostat !== '')
		// {
		// 	const ts = this.getClimateControlByArticle(this.state.currentThermostat);
		//
		// 	if (ts.use_heater !== '1') {
		// 		showThermostatWarn = true;
		// 		thermostatWarnMsg = 'ОБРАТИТЕ ВНИМАНИЕ! Данный термостат предназначен только для регулирования работы вентилятора';
		// 	} else if (ts.use_fan !== '1') {
		// 		showThermostatWarn = true;
		// 		thermostatWarnMsg = 'ОБРАТИТЕ ВНИМАНИЕ! Данный термостат предназначен только для регулирования работы обогревателя';
		// 	}
		// }

		return (
			<div className={styles.cfg}>

				<div className={styles.name}>Конфигуратор подбора климатического оборудования IEK</div>

				{/* Высота, мм */}
				<TextInput x="35" y="131" width="87"
					value={this.state.enclosureHeight} onChange={value => this.setState({enclosureHeight: this.checkNumberInputValue(value)})} />

				{/* Ширина, мм */}
				<TextInput x="35" y="177" width="87"
					value={this.state.enclosureWidth}  onChange={value => this.setState({enclosureWidth: this.checkNumberInputValue(value)})} />

				{/* Глубина, мм */}
				<TextInput x="35" y="222" width="87"
					value={this.state.enclosureDepth}  onChange={value => this.setState({enclosureDepth: this.checkNumberInputValue(value)})} />

				{/* Материал */}
				<Dropdown x="176" y="131" width="99"
					items={[
						{value: 0, text: 'Листовая сталь окрашенная'},
						{value: 1, text: 'Листовая сталь нержавеющая'},
						{value: 2, text: 'Алюминий'},
						{value: 3, text: 'Алюминий двойной'},
						{value: 4, text: 'Поликарбонат, полиэфир'}
					]}
					onItemChange={value => this.setState({enclosureMaterial: value}) }
					value={this.state.enclosureMaterial}
				/>

				{/* Тип установки */}
				<Dropdown x="176" y="177" width="99"
					items={[
						{value: 0, text: 'Отдельно стоящий шкаф, свободный доступ'},
						{value: 1, text: 'Отдельно стоящий шкаф около стены'},
						{value: 2, text: 'Шкаф в конце ряда, свободный доступ'},
						{value: 3, text: 'Шкаф в конце ряда около стены'},
						{value: 4, text: 'Шкаф в середине ряда, свободный доступ'},
						{value: 5, text: 'Шкаф в середине ряда около стены'},
						{value: 6, text: 'Шкаф в середине ряда около стены, с козырьком'}
					]}
					onItemChange={value => this.setState({place: value})}
					value={this.state.place}
				/>


				{/* Мощность, выделяемая оборудованием */}
				<TextInput x="35" y="312" width="100"
					value={this.state.power} onChange={value => this.setState({power: parseInt(this.checkNumberInputValue(value), 10) || 0})} />

				<Button x="147" y="306"
					buttonStyle={styles.mainBtn}
					textStyle={styles.mainBtnTextCentered}
					iconStyle={styles.dwgBtnIcon}
					text="Узнать мощность тепловыделения"
					onClick={() => this.setState(prevState => ({showPowerCalc: !prevState.showPowerCalc}))}
				/>


				{/* Максимальная температура окружающей среды */}
				<TextInput x="35" y="430" width="87"
					value={this.state.envTmax} onChange={value => this.setState({envTmax: this.checkNumberInputValue(value)})} />

				{/* Минимальная температура окружающей среды */}
				<TextInput x="35" y="476" width="87"
					value={this.state.envTmin} onChange={value => this.setState({envTmin: this.checkNumberInputValue(value)})} />

				{/* Высота над уровнем моря */}
				<Dropdown x="35" y="521" width="87"
					items={[
						{value: 0, text: '0–100'},
						{value: 1, text: '100–250'},
						{value: 2, text: '250–500'},
						{value: 3, text: '500–750'},
						{value: 4, text: '750–1000'}
					]}
					onItemChange={value => this.setState({h: value})}
					value={this.state.h}/>

				<div className={styles.insideTmaxLabel}>Расчетная температура внутри шкафа:</div>

				{/* Максимальная внутренняя температура */}
				<TextInput x="177" y="430" width="98"
					value={this.state.insideTmax} onChange={value => this.setState({insideTmax: this.checkNumberInputValue(value)})} />

				{/* Минимальная внутренняя температура */}
				<TextInput x="177" y="476" width="98"
					value={this.state.insideTmin} onChange={value => this.setState({insideTmin: this.checkNumberInputValue(value)})} />


				{/* Подобрать обогреватель */}
				<Button x="365" y="87" buttonStyle={styles.topBtn} buttonDisabledStyle={styles.topBtnDisabled} textStyle={styles.topBtnText}
								text="Подобрать обогреватель" disabled={!(this.state.canPickHeater && calcResults.pheat > 0)} onClick={() => this.onModeChange(MODE_HEATER)} />
				<div className={canPickHeater ? styles.heaterOptions : styles.heaterOptionsDisabled}>
					<label className={styles.heaterOpenAir}><input type="checkbox" disabled={!canPickHeater} checked={this.state.heaterOptionOpenAir}
						onChange={event => this.setState({heaterOptionOpenAir: event.target.checked})} /> Разместить на открытом пространстве</label>
					<label className={styles.heaterSafe}><input type="checkbox" disabled={!canPickHeater} checked={this.state.heaterOptionSafe}
						onChange={event => this.onChangeHeaterType('heaterOptionSafe', event.target.checked)} /> Использовать безопасный обогреватель</label>
					<label className={styles.heaterMini}><input type="checkbox" disabled={!canPickHeater} checked={this.state.heaterOptionMini}
						onChange={event => this.onChangeHeaterType('heaterOptionMini', event.target.checked)} /> Использовать мини-обогреватель (для ЩУ и ЩУРн)</label>

					<label className={styles.heaterPowerful}><input type="checkbox" disabled={!canPickHeater} checked={this.state.heaterOptionPowerful}
						onChange={event => this.onChangeHeaterType('heaterOptionPowerful', event.target.checked)} /> Использовать мощные обогреватели</label>
					<label className={styles.heaterCompactInCase}><input type="checkbox" disabled={!canPickHeater} checked={this.state.heaterOptionCompactInCase}
						onChange={event => this.onChangeHeaterType('heaterOptionCompactInCase', event.target.checked)} /> Использовать компактный в корпусе</label>
					<label className={styles.heaterCompactFlat}><input type="checkbox" disabled={!canPickHeater} checked={this.state.heaterOptionCompactFlat}
						onChange={event => this.onChangeHeaterType('heaterOptionCompactFlat', event.target.checked)} /> Использовать компактный плоский</label>
					<label className={styles.heaterExplosionProofIP65Ex}><input type="checkbox" disabled={!canPickHeater} checked={this.state.heaterOptionExplosionProofIP65Ex}
						onChange={event => this.onChangeHeaterType('heaterOptionExplosionProofIP65Ex', event.target.checked)} /> Использовать взрывозащищенный IP65 Ex</label>
				</div>

				{/* Подобрать вентилятор */}
				<Button x="693" y="87" buttonStyle={styles.topBtn} buttonDisabledStyle={styles.topBtnDisabled} textStyle={styles.topBtnText}
								text="Подобрать вентилятор" disabled={!(this.state.canPickFan && calcResults.airflow > 0)} onClick={() => this.onModeChange(MODE_FAN)} />
				<div className={canPickFan ? styles.fanOptions : styles.fanOptionsDisabled}>
					<label className={styles.fanUseGrill}><input type="checkbox" disabled={!canPickFan} checked={this.state.fanOptionGrill}
						onChange={event => this.setState({fanOptionGrill: event.target.checked})} /> Использовать выпускную решетку с фильтром</label>
					<label className={styles.fanUseHalfClosedGrill}><input type="checkbox" disabled={!canPickFan} checked={this.state.fanOptionHalfClosedGrill}
						onChange={event => this.setState({fanOptionHalfClosedGrill: event.target.checked})} /> Использовать полузакрытый тип решетки</label>
					{/* Тип вентилятора */}
					<Dropdown x="11" y="28" width="184" items={FAN_TYPES} disabled={!canPickFan} />
				</div>

				<div className={styles.fanFlowInfo}>Для расчета потока вентилятора температура Тмах внутри шкафа должна быть больше Тмах окружающей среды</div>

				{/* Устройства контроля */}
				<Dropdown x="365" y="268" width="298"
					label="Устройства контроля:"
					className={styles.controlDeviceLabel}
					disabled={!canPickHeater && !canPickFan}
					items={this.state.climateControls}
					useValueKey={true}
					onItemChange={this.onClimateControlChange} />

				{showThermostatWarn &&
					<span className={styles.thermostatWarn}>{thermostatWarnMsg}</span>
				}

				{/* Подобрать */}
				<Button x="365" y="335"
					buttonStyle={styles.mainBtn}
					buttonDisabledStyle={styles.mainBtnDisabled}
					textStyle={styles.mainBtnTextCentered}
					iconStyle={styles.calcBtnIcon}
					disabled={!canPickHeater && !canPickFan}
					onClick={this.onBtnPickUp}
					text="Подобрать"
				/>

				{/* Список спецификации */}
				<SpecList
					ref="specList"
					items={specList}
					item={this.state.item}
					onSelectItem={this.onSpecListSelectItem}
					onDeleteItem={this.onSpecListDeleteItem}
				/>

				{/* Изображение */}
				<Image
					className={styles.preview}
					url={this.state.item && this.state.item.photo ? `itkcfg.php?type=${this.getType()}&action=getPhoto&article=${this.state.item.article}` : null}
					noPhoto={this.state.item && !this.state.item.photo}
					noPhotoStyle={styles.previewNoPhoto}
				/>

				{/* Описание */}
				{this.state.item && this.state.item.description ? (
					<div className={styles.description}>{this.state.item.description}</div>
				) : (
					<div className={styles.descriptionEmpty} />
				)}

				<div className={styles.calcInfo}>
					Требуемая мощность нагрева: {calcResults.pheat > 0 ? Math.ceil(calcResults.pheat) + ' Вт.' : 'не требуется'}<br/>
					Требуемый воздушный поток: {calcResults.airflow > 0 ? Math.ceil(calcResults.airflow) : 'не требуется'}
						{calcResults.airflow > 0 && <span> м<sup>3</sup>/ч.</span>}
				</div>

				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '723px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#fecd27',
					width: '50%',
					height: '22px',
					top: '723px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '726px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>


				<Button x="34" y="571" buttonStyle={styles.mainBtn} textStyle={styles.mainBtnText}
								iconStyle={styles.pdfBtnIcon} text="Сохранить в PDF" onClick={this.onBtnPrintPdfClick} />

				<Button x="34" y="606" buttonStyle={styles.mainBtn} textStyle={styles.mainBtnText}
								iconStyle={styles.excelBtnIcon} text="Сохранить в Excel" onClick={this.onBtnExcelClick} />

				<Button x="34" y="641" buttonStyle={styles.mainBtn} textStyle={styles.mainBtnText}
								iconStyle={styles.printBtnIcon} text="Распечатать" onClick={this.onBtnPrintClick} />

				<Button x="34" y="676"  style={{width: '183px', height: '35px'}} buttonStyle={styles.mainBtn} textStyle={styles.mainBtnText} disabled={!this.state.item}
								iconStyle={styles.addToCartBtnIcon} text="В корзину" onClick={this.onBtnCartClick} />

				{this.state.showPowerCalc &&
					<PowerCalc onOK={this.onPowerCalcOK} equipmentList={this.state.equipmentList}
						equipmentListTotal={this.state.power} onClose={() => this.setState({showPowerCalc: false})}
						equipment={this.state.equipment} />
				}
			</div>
		);
	}
}


/**
 * Список спецификации (Наименование - Артикул)
 */
class SpecList extends React.Component
{
	render() {
		const rows = !this.props.items ? null : Object.keys(this.props.items).map((article, itemIndex) => {

			const item = this.props.items[article];

			let rowClassName = (itemIndex % 2 === 0 ? `${styles.specListTableRow} ${styles.specListTableRow_even}` : `${styles.specListTableRow}`);

			if (this.props.item && this.props.item.article === article) {
				rowClassName += ` ${styles.specListTableRowSelected}`;
			}

			return (
				<tr key={article} className={rowClassName} onClick={() => this.props.onSelectItem(item)}>
					<td className={`${styles.specListTableRowCell} ${styles.specListTableLeftColumnCell}`}>{item.name}</td>
					<td className={`${styles.specListTableRowCell} ${styles.specListTableRightColumnCell}`}>
						<div className={styles.specListTableRightColumnCellWrapper}>
							<span>{article}</span>
							<span className={styles.specListDelete} title="Удалить позицию"
										onClick={event => {event.stopPropagation(); this.props.onDeleteItem(item);}} />
						</div>
					</td>
				</tr>
			);

		});

		return (
			<div className={styles.specList}>
				<table className={styles.specListTable}>
					<colgroup>
						<col style={{width: '216px'}}/>
						<col style={{width: '96px'}}/>
					</colgroup>
					<tbody>
						{rows}
					</tbody>
				</table>
			</div>
		);
	}
}

/**
 * Узнать мощность тепловыделения
 */
class PowerCalc extends React.Component
{
	constructor(props) {
		super(props);

		this.state = {
			selectedEquipment: 0,
			equipmentList: this.props.equipmentList,
			equipmentListTotal: this.props.equipmentListTotal,
			quantityList: [],
			equipment: this.props.equipment
		};

		this.addEquipment   = this.addEquipment.bind(this);
		this.updateQuantity = this.updateQuantity.bind(this);
		this.onDelete       = this.onDelete.bind(this);
	}

	addEquipment(i, item) {
		this.setState(prevState => {
			const equipment = prevState.equipment[prevState.selectedEquipment];
			const quantity  = (prevState.quantityList[i] > 0 ? prevState.quantityList[i] : 1);

			const equipmentList = prevState.equipmentList.concat([{
				type: equipment.type,
				power: item[item.length - 1],
				quantity
			}]);

			const equipmentListTotal = prevState.equipmentListTotal + parseInt(item[item.length - 1], 10) * quantity;

			return {
				equipmentList,
				equipmentListTotal
			};
		});
	}

	updateQuantity(i, value) {
		this.setState(prevState => {
			const quantityList = prevState.quantityList.slice();

			quantityList[i] = value;

			return {
				quantityList
			};
		});
	}

	onDelete(i) {
		this.setState(prevState => {
			const equipmentList = prevState.equipmentList.slice();
			const [item] = equipmentList.splice(i, 1);
			const equipmentListTotal = prevState.equipmentListTotal - (item.power * item.quantity);

			return {
				equipmentList,
				equipmentListTotal
			};
		});
	}

	render() {
		const equipment = this.state.equipment[this.state.selectedEquipment];

		return (
			<div className={styles.powerCalc}>

				<div className={styles.btnClose} onClick={this.props.onClose} />

				<div className={styles.powerCalc_TypeLabel}>Тип оборудования:</div>

				<select className={styles.powerCalc_TypeSelect} value={this.state.selectedEquipment} onChange={e => this.setState({selectedEquipment: e.target.value, quantityList: []})}>
					{this.state.equipment.map((eq, i) =>
						<option key={i} value={i}>{eq.type}</option>
					)}
				</select>

				<div className={styles.powerCalc_TableWrap}>
					<table className={styles.powerCalc_Table}>
						<thead>
							<tr>
								{equipment.headers.map(header =>
									<th key={header}>{header}</th>
								)}
								<th>Количество</th>
								<th>Выделяемое тепло суммарно, Вт</th>
								<th>&nbsp;</th>
							</tr>
						</thead>
						<tbody>
							{equipment.items.map((item, i) =>
								<tr key={equipment.type + i}>
									{item.map(val =>
										<td key={val}>{val}</td>
									)}

									<td>
										<input className={styles.powerCalc_TableQuantity} type="number" min="1" defaultValue={1} onChange={e => this.updateQuantity(i, e.target.value)} />
									</td>

									<td>
										{(this.state.quantityList[i] > 0 ? this.state.quantityList[i] : 1) * parseInt(item[item.length - 1], 10)}
									</td>

									<td>
										<button onClick={() => this.addEquipment(i, item)}>Добавить</button>
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>

				<div className={styles.powerCalc_TableListWrap}>
					<table className={styles.powerCalc_Table}>
						<tbody>
							{this.state.equipmentList.map((eq, i) =>
								<tr key={i}>
									<td>{eq.quantity} x {eq.type} ({eq.power} Вт)</td>
									<td>{eq.power * eq.quantity} Вт</td>
									<td><button onClick={() => this.onDelete(i)}>Удалить</button></td>
								</tr>
							)}
						</tbody>
					</table>
				</div>

				<div className={styles.powerCalc_TotalLabel}>Всего, Вт</div>
				<div className={styles.powerCalc_Total}>{this.state.equipmentListTotal}</div>
				<button className={styles.powerCalc_OK} onClick={() => this.props.onOK(this.state.equipmentListTotal, this.state.equipmentList)}>OK</button>
			</div>
		);
	}
}

export default EnclosureClimateConfigurator;



// WEBPACK FOOTER //
// ./src/react/EnclosureClimateConfigurator.jsx